import * as moment from 'moment';
import { Moment } from 'moment';
import { EtaEmitter } from './eta-emitter.enum';
import { Latng } from '../../shared/latng';
import { DeliveryEventSource } from './delivery-event-source.enum';

export class EtaDetail {

  id: string;

  emitter: EtaEmitter;

  eta: Moment;

  eventSource: DeliveryEventSource;

  calculationDate: Moment;

  sentToMyChep: boolean;

  destinationTimezoneOffset: string;

  latitude: number;

  longitude: number;



  static fromDto(etaDetailDto): EtaDetail {
    const etaDetail = new EtaDetail();

    etaDetail.id = etaDetailDto.id;
    etaDetail.emitter = etaDetailDto.emitter as EtaEmitter;
    etaDetail.eta = etaDetailDto.eta ? moment(etaDetailDto.eta) : null;
    etaDetail.eventSource = etaDetailDto.eventSource as DeliveryEventSource;
    etaDetail.sentToMyChep = etaDetailDto.sentToMyChep || false;
    etaDetail.calculationDate = etaDetailDto.calculationDate ? moment(etaDetailDto.calculationDate) : null;
    etaDetail.destinationTimezoneOffset = etaDetailDto.destinationTimezoneOffset || null;
    etaDetail.latitude = etaDetailDto.latitude || null;
    etaDetail.longitude = etaDetailDto.longitude || null;

    return etaDetail;
  }

}
